"use client";

import { useState, useEffect } from "react";

interface RotatingTextProps {
  items: string[];
  /** milliseconds each item stays visible (default 2800) */
  interval?: number;
}

export default function RotatingText({ items, interval = 2800 }: RotatingTextProps) {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const cycle = setInterval(() => {
      // fade out
      setVisible(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % items.length);
        setVisible(true);
      }, 350); // must match transition duration below
    }, interval);

    return () => clearInterval(cycle);
  }, [items, interval]);

  return (
    <span className={`rotating-text ${visible ? "rotating-text-visible" : "rotating-text-hidden"}`}>
      {items[index]}
    </span>
  );
}
